// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M13.6364 10.2H11V9L13.6365 9.00019C13.6424 9.00085 13.6691 9.0039 13.7084 9.01774C13.7543 9.03395 13.7991 9.05862 13.8367 9.09099C13.8716 9.12098 13.9072 9.1631 13.9366 9.22932C13.9662 9.29632 14 9.41198 14 9.6C14 9.78802 13.9662 9.90368 13.9366 9.97068C13.9072 10.0369 13.8716 10.079 13.8367 10.109C13.7991 10.1414 13.7543 10.166 13.7084 10.1823C13.6691 10.1961 13.6422 10.1993 13.6364 10.2Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M10.1145 21.8111C10.7214 22.3105 11.3529 22.7684 12 23.2136C12.6472 22.7686 13.2782 22.3109 13.8854 21.8112C14.6614 21.1727 15.6981 20.2496 16.738 19.1123C18.7821 16.8765 21 13.6373 21 10C21 5.02944 16.9706 1 12 1C7.02944 1 3 5.02944 3 10C3 13.637 5.2179 16.8762 7.26196 19.112C8.30183 20.2494 9.33859 21.1725 10.1145 21.8111ZM13.6364 7C14.08 7 14.6584 7.15994 15.1405 7.57439C15.6602 8.02115 16 8.70534 16 9.6C16 10.4947 15.6602 11.1788 15.1405 11.6256C14.6584 12.0401 14.08 12.2 13.6364 12.2H11V15H9V7H13.6364Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-location-parking-place-filled')
export default class LocationParkingPlaceFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'location-parking-place-filled',
    }
  }
}
